{
  "version": 1,
  "asset_id": "58abaf1a-11ca-40ec-a927-cb839c0cd841",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/58abaf1a-11ca-40ec-a927-cb839c0cd841/hiatal-type-iv-patient-before-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/58abaf1a-11ca-40ec-a927-cb839c0cd841/hiatal-type-iv-patient-before-800.webp",
  "original_filename": "hiatal-type-iv-patient-before-800.webp",
  "size": 61288,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:43Z"
}
